import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import logo from "../assets/ZilkerWDDark.png";

function NewNav() {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  return (
    <nav className="font-inter bg-[#2E2D2B] text-white w-full z-50 relative">
      <div className="flex items-center justify-between md:justify-center px-4 py-4 md:px-10 max-w-screen-2xl mx-auto relative">

        {/* LEFT MENU */}
        <div className="hidden md:flex space-x-6 uppercase font-semibold text-[15px] absolute left-10 top-1/2 -translate-y-1/2">

          {/* WORK WITH ME */}
          <div
            className="relative group"
            onMouseEnter={() => setOpenDropdown('work')}
            onMouseLeave={() => setOpenDropdown(null)} // This onMouseLeave should be on the parent div that contains both the link and the dropdown
          >
          <a href='/services'>
            <span className="cursor-pointer pl-8">WORK WITH ME</span>
            {/* {openDropdown === 'work' && (
              <div className="absolute left-0 mt-2 bg-[#2E2D2B] w-64 shadow-lg rounded z-50">
                <a href="/LaunchGlowUp" className="block px-4 py-2 hover:bg-[#CFF098] hover:text-black">Authority Launchpad</a>
                <a href="/strategicgrowthaccelerator" className="block px-4 py-2 hover:bg-[#CFF098] hover:text-black">Growth Accelerator</a>
                <a href="/authorityamplifier" className="block px-4 py-2 hover:bg-[#CFF098] hover:text-black">Authority Amplifier</a>
                <a href="/services" className="block px-4 py-2 hover:bg-[#CFF098] hover:text-black">Other Services</a>
              </div>
            )} */}
            </a>
          </div>

          {/* CLIENT WORK */}
          <div
            className="relative group"
            onMouseEnter={() => setOpenDropdown('client')}
            onMouseLeave={() => setOpenDropdown(null)} // Apply to the parent div
          >
          <a href='/casestudies'>
            <span className="cursor-pointer pl-8">CLIENT WORK</span>
            {/* {openDropdown === 'client' && (
              <div className="absolute left-0 mt-2 bg-[#2E2D2B] w-48 shadow-lg rounded z-50">
                <a href="/casestudies" className="block px-4 py-2 hover:bg-[#CFF098] hover:text-black">Case Studies</a>
                <a href="/testimonials" className="block px-4 py-2 hover:bg-[#CFF098] hover:text-black">Testimonials</a>
              </div>
            )} */}
            </a>
          </div>

          {/* TEMPLATE SHOP */}
          <div
            className="relative group"
            onMouseEnter={() => setOpenDropdown('shop')}
            onMouseLeave={() => setOpenDropdown(null)} // Apply to the parent div
          >

           <a href='/shop'>
            <span className="cursor-pointer pl-8">TEMPLATE SHOP</span>
            {/* {openDropdown === 'shop' && (
              <div className="absolute left-0 mt-2 bg-[#2E2D2B] w-48 shadow-lg rounded z-50">
                <a href="/wix-templates" className="block px-4 py-2 hover:bg-[#CFF098] hover:text-black">Wix Templates</a>
                <a href="/wordpress-templates" className="block px-4 py-2 hover:bg-[#CFF098] hover:text-black">WordPress Templates</a>
              </div>
            )} */}
            </a>
          </div>
        </div>

        {/* LOGO */}
        <div className="flex-shrink-0 z-50">
          <a href="/">
            <img src={logo} alt="Logo" className="h-16 md:h-20 mx-auto" />
          </a>
        </div>

        {/* RIGHT MENU */}
        <div className="hidden md:flex space-x-6 uppercase font-semibold text-[15px] absolute right-20 top-1/2 -translate-y-1/2 items-center">
          <a href="/blog" className='pl-20'>BLOG</a>
          <a href="/resources" className='pl-12'>RESOURCES</a>
          <a href="/about" className='pl-12 pr-10'>ABOUT</a>
          <a
            href="/contact"
            className="text-white px-4 py-2 rounded-full  hover:opacity-80"
          >
            Inquire
          </a>
        </div>

        {/* MOBILE MENU ICON */}
        <button
          className="md:hidden z-50 text-white"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle mobile menu"
        >
          {isOpen ? <X size={30} /> : <Menu size={30} />}
        </button>
      </div>

      {/* MOBILE MENU */}
      {isOpen && (
        <div className="md:hidden bg-[#2E2D2B] text-white px-6 py-6 space-y-4 flex flex-col items-start font-bold uppercase text-sm z-40">
          <a href="/" className="hover:text-[#CFF098]">Home</a>
          <a href="/services" className="hover:text-[#CFF098]">Work With Me</a>
          <a href="/client-work" className="hover:text-[#CFF098]">Client Work</a>
          <a href="/template-shop" className="hover:text-[#CFF098]">Template Shop</a>
          <a href="/blog" className="hover:text-[#CFF098]">Blog</a>
          <a href="/resources" className="hover:text-[#CFF098]">Resources</a>
          <a href="/about" className="hover:text-[#CFF098]">About</a>
          <a href="/contact" className="hover:text-black bg-[#CFF098] px-4 py-2 rounded-full">Inquire</a>
        </div>
      )}
    </nav>
  );
}

export default NewNav;